export default function DecisionFinalePage() {

    const GOLD = "#C9A96E";
    const INK = "#1C1915";
    const INK_SOFT = "#4A4540";
    const BORDER = "#E7E1D8";
    const SOFT_BG = "#F7F5F2";
  
    const cardStyle = {
      background: "#fff",
      border: `1px solid ${BORDER}`,
      borderRadius: 12,
      padding: 22,
    };
  
    const labelStyle = {
      fontSize: 11,
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      color: INK_SOFT,
      fontWeight: 600,
      marginBottom: 6,
      display: "block",
    };
  
    const inputStyle = {
      width: "100%",
      padding: "10px 12px",
      border: `1px solid ${BORDER}`,
      borderRadius: 8,
      fontSize: 13,
      background: SOFT_BG,
      boxSizing: "border-box",
    };
  
    const textareaStyle = {
      width: "100%",
      minHeight: 120,
      padding: "10px 12px",
      border: `1px solid ${BORDER}`,
      borderRadius: 8,
      fontSize: 13,
      resize: "vertical",
      background: SOFT_BG,
      boxSizing: "border-box",
    };
  
    return (
      <div style={{ maxWidth: 1100, fontFamily: "system-ui, sans-serif" }}><div style={{ marginBottom: 24 }}><div style={{
            fontSize: 11,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: GOLD,
            marginBottom: 6,
          }}>
            Décision
          </div><div style={{
            fontSize: 24,
            fontWeight: 700,
            color: INK
          }}>
            Décision finale
          </div><div style={{
            fontSize: 13,
            color: INK_SOFT,
            marginTop: 4
          }}>
            Validation finale avant passage en contractualisation.
          </div></div><div style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 18
        }}><div style={cardStyle}><label style={labelStyle}>Décision</label><select style={inputStyle}><option>GO</option><option>GO sous conditions</option><option>À revoir</option><option>NO GO</option></select></div><div style={cardStyle}><label style={labelStyle}>Niveau de confiance</label><select style={inputStyle}><option>Élevé</option><option>Moyen</option><option>Faible</option></select></div><div style={{ ...cardStyle, gridColumn: "1 / -1" }}><label style={labelStyle}>Motivation de la décision</label><textarea
              style={textareaStyle}
              placeholder="Explique pourquoi le projet est validé, refusé ou conditionné..."
            /></div><div style={{ ...cardStyle, gridColumn: "1 / -1" }}><label style={labelStyle}>Conditions avant contractualisation</label><textarea
              style={textareaStyle}
              placeholder="Ex : validation budget, vérification foncière, planning validé..."
            /></div></div></div>
    );
  }